<template>
    <VForm
        v-slot="{ form }"
        :on-submit-async="submit"
        @success="(value)=>this.$emit('success',value)">
        <BannerMediaCreateAndUpdateFormItems :form="form" :data="bannerMedia" />
    </VForm>
</template>
<script>
import { rootActions, Getters } from '@/store/types'
import VForm from '@/components/VForm.vue'
import BannerMediaCreateAndUpdateFormItems from '@/components/BannerMediaCreateAndUpdateFormItems.vue'

export default {
    components: {
        VForm,
        BannerMediaCreateAndUpdateFormItems,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    computed: {
        bannerMedia () {
            return this.$store.getters[Getters.banner.GET_BANNER_MEDIA](this.id)
        },
    },
    methods: {
        async submit (values) {
            const res = await this.$store.dispatch(
                rootActions.UPDATE_BANNER_MEDIA, { id: this.id, ...values },
            )
            return res
        },
    },
}
</script>
